/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuImage } from '@neutron/react';

/**
 * Global Type Definition Imports
 */
import { AuthUserProps } from '../../../config/interfaces';

/**
 * Style Imports
 */
import {
  Avatar,
  UserInfoCard,
  UserInfoAvatar,
  UserInfoContent,
  UserInfoName,
  UserInfoDetails
} from './UserModal.styles';

/**
 * Static File Imports
 */
import defaultImage from '../../../assets/images/defaultImage.png';

interface IUserInfoProps {
  userDetails: AuthUserProps;
}

const UserInfo: FC<IUserInfoProps> = ({ userDetails }): JSX.Element => {
  return (
    <UserInfoCard unit="card" kind="flat">
      <UserInfoAvatar unit="header">
        <Avatar unit="avatar" color="gray" size="large">
          <NeuImage src={defaultImage} alt="User Image" />
        </Avatar>
      </UserInfoAvatar>
      <UserInfoContent unit="content">
        <UserInfoName>{`${userDetails.firstName} ${userDetails.lastName} | ${userDetails.hcaid}`}</UserInfoName>
        <UserInfoDetails>
          {userDetails.email
            ? userDetails.email.toString().toLowerCase()
            : 'Unknown'}
        </UserInfoDetails>
        <UserInfoDetails>{userDetails.title || 'Unknown'}</UserInfoDetails>
        <UserInfoDetails>{userDetails.dept || 'Unknown'}</UserInfoDetails>
      </UserInfoContent>
    </UserInfoCard>
  );
};

export default UserInfo;
